import React from "react";
import { customers } from "../data/customers";
import { useLang } from "../i18n/LanguageContext";

const ClientMarquee = () => {
  const { t } = useLang();
  const items = [...customers, ...customers]; // duplicate for seamless loop

  return (
    <section className="bg-[#F7F7F5] border-y border-neutral-200" data-testid="client-marquee">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14">
        <p className="text-center text-xs font-bold tracking-[0.3em] uppercase text-neutral-500 mb-8">
          {t.home.trustedBy}
        </p>
        <div className="relative overflow-hidden">
          <div className="flex gap-12 animate-marquee whitespace-nowrap w-max">
            {items.map((c, i) => (
              <div
                key={i}
                data-testid={`customer-${i}`}
                className="flex items-center gap-3 text-neutral-700"
              >
                <span className="w-2 h-2 bg-[#C8102E]" />
                <span className="text-[15px] font-semibold tracking-tight">{c.name}</span>
              </div>
            ))}
          </div>
          {/* Edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#F7F7F5] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#F7F7F5] to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default ClientMarquee;
